import { render, staticRenderFns } from "./RegexPicker.vue?vue&type=template&id=20a6b17a"
import script from "./RegexPicker.vue?vue&type=script&lang=js"
export * from "./RegexPicker.vue?vue&type=script&lang=js"
import style0 from "./RegexPicker.vue?vue&type=style&index=0&id=20a6b17a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports